<script setup lang="ts">
import { ToastProvider } from '@idcapture/design-system';
import ImpersonationBanner from '@/shared/ui/ImpersonationBanner.vue';
</script>

<template>
  <!-- Au-dessus de la vue, et non dans un layout : une session usurpée se signale sur
       toutes les pages, y compris celles de l'administration et la page introuvable. -->
  <ImpersonationBanner />
  <RouterView />
  <!-- Mounted once, at the root: the administration's confirmations are dispatched from a
       page that unmounts as soon as the action has been taken. -->
  <ToastProvider position="bottom-right" />
</template>
